
import { useState } from 'react';

export default function HomePage() {
  const [formData, setFormData] = useState({
    nombre: '',
    mensaje: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const formDataToSend = new FormData();
      formDataToSend.append('nombre', formData.nombre);
      formDataToSend.append('mensaje', formData.mensaje);

      const response = await fetch('https://readdy.ai/api/form/d45f1c7gaed3g6l51t7g', {
        method: 'POST',
        body: formDataToSend
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ nombre: '', mensaje: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const scrollToContact = () => {
    document.getElementById('contacto')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-slate-950">
      {/* Navigation */}
      <nav className="bg-slate-950/95 backdrop-blur-sm border-b border-slate-800/50 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <h1 className="text-2xl font-bold text-white tracking-wide" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '700' }}>
                <span className="text-slate-200">G</span>
                <span className="text-orange-500">L</span>
                <span className="text-slate-200">CC</span>
              </h1>
            </div>
            <div className="hidden md:flex items-center space-x-8">
              <a href="#inicio" className="text-slate-400 hover:text-orange-400 font-medium cursor-pointer transition-colors" style={{ fontFamily: '"Inter", sans-serif' }}>Inicio</a>
              <a href="#servicios" className="text-slate-400 hover:text-orange-400 font-medium cursor-pointer transition-colors" style={{ fontFamily: '"Inter", sans-serif' }}>Servicios</a>
              <a href="#nosotros" className="text-slate-400 hover:text-orange-400 font-medium cursor-pointer transition-colors" style={{ fontFamily: '"Inter", sans-serif' }}>Nosotros</a>
              <a href="#contacto" className="bg-gradient-to-r from-orange-500 to-orange-600 text-slate-950 px-6 py-2 rounded-lg font-semibold cursor-pointer hover:from-orange-600 hover:to-orange-700 transition-all whitespace-nowrap" style={{ fontFamily: '"Inter", sans-serif' }}>
                Contactar
              </a>
            </div>
            <button className="md:hidden">
              <i className="ri-menu-line text-2xl text-slate-400"></i>
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="inicio" className="relative bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 text-white overflow-hidden min-h-screen flex items-center">
        {/* Animated Background Elements */}
        <div className="absolute inset-0">
          <div className="absolute top-20 left-10 w-72 h-72 bg-orange-500/8 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-slate-700/10 rounded-full blur-3xl animate-pulse delay-1000"></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gradient-to-r from-orange-500/5 to-slate-700/5 rounded-full blur-3xl"></div>
        </div>
        
        {/* Grid Pattern */}
        <div className="absolute inset-0 bg-[linear-gradient(rgba(249,115,22,0.08)_1px,transparent_1px),linear-gradient(90deg,rgba(249,115,22,0.08)_1px,transparent_1px)] bg-[size:50px_50px]"></div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-32 w-full">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="max-w-3xl">
              <div className="inline-flex items-center px-4 py-2 bg-slate-900/50 border border-orange-500/20 rounded-lg mb-8">
                <div className="w-2 h-2 bg-orange-500 rounded-full mr-3 animate-pulse"></div>
                <span className="text-orange-400 text-sm font-medium" style={{ fontFamily: '"Inter", sans-serif' }}>Tecnología Financiera Avanzada</span>
              </div>
              
              <h2 className="text-4xl lg:text-6xl font-bold mb-6 leading-tight" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '800' }}>
                <span className="text-slate-200">Soluciones Financieras</span>
                <span className="block text-orange-500">Inteligentes</span>
                <span className="text-slate-300">para el Mundo Digital</span>
              </h2>
              
              <p className="text-xl lg:text-2xl mb-8 text-slate-400 leading-relaxed" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '400' }}>
                Operaciones OTC, P2P, B2B y más. Tu aliado estratégico en el comercio de criptomonedas.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4">
                <button 
                  onClick={scrollToContact}
                  className="bg-gradient-to-r from-orange-500 to-orange-600 text-slate-950 px-8 py-4 rounded-lg font-bold text-lg hover:from-orange-600 hover:to-orange-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg shadow-orange-500/20" 
                  style={{ fontFamily: '"Inter", sans-serif', fontWeight: '700' }}
                >
                  ¡Conoce GLCC hoy!
                </button>
                <button className="border border-slate-700 text-slate-300 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-slate-900 hover:border-orange-500/50 transition-all whitespace-nowrap cursor-pointer" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '600' }}>
                  Ver Demo
                </button>
              </div>
            </div>
            
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-orange-500/15 to-slate-700/15 rounded-3xl blur-xl"></div>
              <img 
                src="https://public.readdy.ai/ai/img_res/0f35b98ea5b478b8000e122014634084.jpg"
                alt="Tecnología Financiera GLCC"
                className="relative rounded-3xl shadow-2xl w-full h-96 object-cover object-center border border-slate-800/50"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-16 bg-slate-900/50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center group">
              <div className="w-16 h-16 bg-gradient-to-br from-green-500/15 to-green-600/15 border border-green-500/20 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                <i className="ri-shield-check-line text-2xl text-green-400"></i>
              </div>
              <h3 className="font-bold text-slate-200 mb-2" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '700' }}>Seguro</h3>
              <p className="text-slate-500 text-sm" style={{ fontFamily: '"Inter", sans-serif' }}>Protección avanzada de datos</p>
            </div>
            <div className="text-center group">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500/15 to-orange-600/15 border border-orange-500/20 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                <i className="ri-speed-line text-2xl text-orange-400"></i>
              </div>
              <h3 className="font-bold text-slate-200 mb-2" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '700' }}>Ágil</h3>
              <p className="text-slate-500 text-sm" style={{ fontFamily: '"Inter", sans-serif' }}>Operaciones rápidas y eficientes</p>
            </div>
            <div className="text-center group">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-500/15 to-blue-600/15 border border-blue-500/20 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                <i className="ri-eye-line text-2xl text-blue-400"></i>
              </div>
              <h3 className="font-bold text-slate-200 mb-2" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '700' }}>Transparent</h3>
              <p className="text-slate-500 text-sm" style={{ fontFamily: '"Inter", sans-serif' }}>Total trazabilidad financiera</p>
            </div>
            <div className="text-center group">
              <div className="w-16 h-16 bg-gradient-to-br from-slate-600/15 to-slate-700/15 border border-slate-600/20 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                <i className="ri-settings-3-line text-2xl text-slate-400"></i>
              </div>
              <h3 className="font-bold text-slate-200 mb-2" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '700' }}>Eficiente</h3>
              <p className="text-slate-500 text-sm" style={{ fontFamily: '"Inter", sans-serif' }}>Máxima optimización</p>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="nosotros" className="py-20 bg-slate-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center px-4 py-2 bg-slate-900/50 border border-orange-500/20 rounded-lg mb-6">
              <span className="text-orange-400 font-semibold" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '600' }}>¿QUIÉNES SOMOS?</span>
            </div>
            <h2 className="text-4xl font-bold text-slate-200 mb-8" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '800' }}>
              Transformando el presente,
              <span className="block text-orange-500">impulsando el futuro</span>
            </h2>
          </div>
          
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold text-orange-500 mb-6" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '800' }}>GLCC</h3>
              <p className="text-slate-400 text-lg leading-relaxed mb-8" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '400' }}>
                GLCC es una empresa especializada en ofrecer soluciones financieras avanzadas en el mercado de las criptomonedas. Diseñamos herramientas y estrategias para personas, empresas y organizaciones que buscan operaciones seguras, rápidas y de gran volumen.
              </p>
              <p className="text-slate-400 text-lg leading-relaxed mb-8" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '400' }}>
                Con una comprensión profunda del mercado cripto y financiero, facilitamos transacciones a través de plataformas OTC, P2P, swaps, B2B y más, garantizando transparencia, liquidez y seguridad en cada movimiento.
              </p>
              
              <div className="space-y-6">
                <div className="flex items-start space-x-4 p-4 bg-slate-900/30 border border-slate-800/50 rounded-xl hover:border-orange-500/30 transition-colors">
                  <div className="w-12 h-12 bg-gradient-to-br from-orange-500/15 to-orange-600/15 border border-orange-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-exchange-line text-xl text-orange-400"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-slate-200 mb-2" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '700' }}>Soluciones integrales para el comercio cripto</h4>
                    <p className="text-slate-500" style={{ fontFamily: '"Inter", sans-serif' }}>Ofrecemos plataformas y canales eficientes que permiten operaciones de alto volumen con total confianza.</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4 p-4 bg-slate-900/30 border border-slate-800/50 rounded-xl hover:border-orange-500/30 transition-colors">
                  <div className="w-12 h-12 bg-gradient-to-br from-green-500/15 to-green-600/15 border border-green-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-group-line text-xl text-green-400"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-slate-200 mb-2" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '700' }}>Transacciones OTC y P2P</h4>
                    <p className="text-slate-500" style={{ fontFamily: '"Inter", sans-serif' }}>Intercambios directos, flexibles y confiables.</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4 p-4 bg-slate-900/30 border border-slate-800/50 rounded-xl hover:border-orange-500/30 transition-colors">
                  <div className="w-12 h-12 bg-gradient-to-br from-blue-500/15 to-blue-600/15 border border-blue-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-customer-service-line text-xl text-blue-400"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-slate-200 mb-2" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '700' }}>Atención profesional</h4>
                    <p className="text-slate-500" style={{ fontFamily: '"Inter", sans-serif' }}>Soporte continuo y acompañamiento experto.</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-orange-500/10 to-slate-700/10 rounded-2xl blur-xl"></div>
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20cryptocurrency%20financial%20team%20working%20in%20modern%20office%20with%20dark%20navy%20blue%20environment%20and%20orange%20accent%20lighting%2C%20multiple%20monitors%20displaying%20crypto%20charts%20and%20blockchain%20data%2C%20futuristic%20workspace%20with%20holographic%20displays%2C%20team%20collaboration%20in%20fintech%20company%20with%20dark%20blue%20and%20orange%20corporate%20colors&width=600&height=400&seq=about-glcc-team-v3&orientation=landscape"
                alt="Equipo GLCC"
                className="relative rounded-2xl shadow-2xl w-full h-96 object-cover object-top border border-slate-800/50"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="servicios" className="py-20 bg-slate-900/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center px-4 py-2 bg-slate-900/50 border border-orange-500/20 rounded-lg mb-6">
              <span className="text-orange-400 font-semibold" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '600' }}>SERVICIOS</span>
            </div>
            <h2 className="text-4xl font-bold text-slate-200" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '800' }}>
              Brindando soluciones
              <span className="block text-orange-500">innovadoras</span>
            </h2>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* OTC Operations */}
            <div className="bg-slate-900/50 backdrop-blur-sm border border-slate-800/50 rounded-2xl p-8 hover:border-orange-500/30 transition-all hover:shadow-lg hover:shadow-orange-500/10 group">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500/15 to-orange-600/15 border border-orange-500/20 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-bank-line text-2xl text-orange-400"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-200 mb-4" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '700' }}>
                Operaciones OTC<br />
                <span className="text-sm font-normal text-slate-500" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '400' }}>(Over-The-Contract)</span>
              </h3>
              <p className="text-slate-400 mb-4" style={{ fontFamily: '"Inter", sans-serif' }}>Ejecución de operaciones privadas y de alto volumen sin impacto en el mercado.</p>
              <p className="text-sm text-slate-500" style={{ fontFamily: '"Inter", sans-serif' }}>
                Conectamos compradores y vendedores institucionales para garantizar liquidez, rapidez y confidencialidad.
              </p>
            </div>

            {/* P2P Operations */}
            <div className="bg-slate-900/50 backdrop-blur-sm border border-slate-800/50 rounded-2xl p-8 hover:border-orange-500/30 transition-all hover:shadow-lg hover:shadow-orange-500/10 group">
              <div className="w-16 h-16 bg-gradient-to-br from-green-500/15 to-green-600/15 border border-green-500/20 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-user-line text-2xl text-green-400"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-200 mb-4" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '700' }}>
                Operaciones P2P<br />
                <span className="text-sm font-normal text-slate-500" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '400' }}>(Peer-to-Peer)</span>
              </h3>
              <p className="text-slate-400 mb-4" style={{ fontFamily: '"Inter", sans-serif' }}>Comercio directo entre usuarios con total seguridad.</p>
              <p className="text-sm text-slate-500" style={{ fontFamily: '"Inter", sans-serif' }}>
                Facilitamos compras y ventas de criptomonedas de forma eficiente, optimizando tiempos y costos operativos.
              </p>
            </div>

            {/* B2B Operations */}
            <div className="bg-slate-900/50 backdrop-blur-sm border border-slate-800/50 rounded-2xl p-8 hover:border-orange-500/30 transition-all hover:shadow-lg hover:shadow-orange-500/10 group">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-500/15 to-blue-600/15 border border-blue-500/20 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-building-line text-2xl text-blue-400"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-200 mb-4" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '700' }}>
                Operaciones B2B<br />
                <span className="text-sm font-normal text-slate-500" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '400' }}>(Business-to-Business)</span>
              </h3>
              <p className="text-slate-400 mb-4" style={{ fontFamily: '"Inter", sans-serif' }}>Soluciones a la medida para empresas que desean integrar criptomonedas en sus operaciones.</p>
              <p className="text-sm text-slate-500" style={{ fontFamily: '"Inter", sans-serif' }}>
                Ofrecemos servicios de conversión, pagos internacionales y liquidez corporativa.
              </p>
            </div>

            {/* P2B and B2P Operations */}
            <div className="bg-slate-900/50 backdrop-blur-sm border border-slate-800/50 rounded-2xl p-8 hover:border-orange-500/30 transition-all hover:shadow-lg hover:shadow-orange-500/10 group">
              <div className="w-16 h-16 bg-gradient-to-br from-purple-500/15 to-purple-600/15 border border-purple-500/20 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-links-line text-2xl text-purple-400"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-200 mb-4" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '700' }}>Operaciones P2B y B2P</h3>
              <p className="text-slate-400 mb-4" style={{ fontFamily: '"Inter", sans-serif' }}>Conectamos empresas y usuarios mediante soluciones tecnológicas que agilizan los procesos financieros cripto.</p>
            </div>

            {/* Crypto Swaps */}
            <div className="bg-slate-900/50 backdrop-blur-sm border border-slate-800/50 rounded-2xl p-8 hover:border-orange-500/30 transition-all hover:shadow-lg hover:shadow-orange-500/10 group">
              <div className="w-16 h-16 bg-gradient-to-br from-indigo-500/15 to-indigo-600/15 border border-indigo-500/20 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-shuffle-line text-2xl text-indigo-400"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-200 mb-4" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '700' }}>Swaps de Criptomonedas</h3>
              <p className="text-slate-400 mb-4" style={{ fontFamily: '"Inter", sans-serif' }}>Intercambia criptomonedas de forma inmediata y sin complicaciones.</p>
              <p className="text-sm text-slate-500" style={{ fontFamily: '"Inter", sans-serif' }}>
                Ideal para quienes buscan diversificar portafolios o optimizar posiciones de mercado.
              </p>
            </div>

            {/* Arbitrage */}
            <div className="bg-slate-900/50 backdrop-blur-sm border border-slate-800/50 rounded-2xl p-8 hover:border-orange-500/30 transition-all hover:shadow-lg hover:shadow-orange-500/10 group">
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500/15 to-teal-600/15 border border-teal-500/20 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-scales-line text-2xl text-teal-400"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-200 mb-4" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '700' }}>Arbitraje de Criptomonedas</h3>
              <p className="text-slate-400 mb-4" style={{ fontFamily: '"Inter", sans-serif' }}>Aprovecha las oportunidades de precio entre distintas plataformas.</p>
              <p className="text-sm text-slate-500" style={{ fontFamily: '"Inter", sans-serif' }}>
                Ejecutamos operaciones rentables basadas en diferencias de cotización entre exchanges.
              </p>
            </div>

            {/* Payment Dispersion */}
            <div className="bg-slate-900/50 backdrop-blur-sm border border-slate-800/50 rounded-2xl p-8 hover:border-orange-500/30 transition-all hover:shadow-lg hover:shadow-orange-500/10 group">
              <div className="w-16 h-16 bg-gradient-to-br from-pink-500/15 to-pink-600/15 border border-pink-500/20 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-send-plane-line text-2xl text-pink-400"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-200 mb-4" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '700' }}>Dispersión de Pagos</h3>
              <p className="text-slate-400 mb-4" style={{ fontFamily: '"Inter", sans-serif' }}>Soluciones tecnológicas para pagos masivos y automatizados.</p>
              <p className="text-sm text-slate-500" style={{ fontFamily: '"Inter", sans-serif' }}>
                Ideal para empresas que requieren enviar múltiples pagos de forma rápida y segura.
              </p>
            </div>

            {/* Crypto Monetization */}
            <div className="bg-slate-900/50 backdrop-blur-sm border border-slate-800/50 rounded-2xl p-8 hover:border-orange-500/30 transition-all hover:shadow-lg hover:shadow-orange-500/10 group">
              <div className="w-16 h-16 bg-gradient-to-br from-yellow-500/15 to-yellow-600/15 border border-yellow-500/20 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-money-dollar-circle-line text-2xl text-yellow-400"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-200 mb-4" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '700' }}>Monetización Cripto</h3>
              <p className="text-slate-400 mb-4" style={{ fontFamily: '"Inter", sans-serif' }}>Convierte tus criptomonedas en liquidez real.</p>
              <p className="text-sm text-slate-500" style={{ fontFamily: '"Inter", sans-serif' }}>
                Facilitamos la conversión de cripto a moneda local con eficiencia y trazabilidad.
              </p>
            </div>

            {/* On/Off Ramp */}
            <div className="bg-slate-900/50 backdrop-blur-sm border border-slate-800/50 rounded-2xl p-8 hover:border-orange-500/30 transition-all hover:shadow-lg hover:shadow-orange-500/10 group">
              <div className="w-16 h-16 bg-gradient-to-br from-emerald-500/15 to-emerald-600/15 border border-emerald-500/20 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-exchange-funds-line text-2xl text-emerald-400"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-200 mb-4" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '800' }}>Operaciones On-Ramp y Off-Ramp</h3>
              <p className="text-slate-400 mb-4" style={{ fontFamily: '"Inter", sans-serif' }}>Puente entre el mundo cripto y el sistema financiero tradicional.</p>
              <p className="text-sm text-slate-500" style={{ fontFamily: '"Inter", sans-serif' }}>
                Permite convertir cripto a fiat y viceversa mediante procesos automatizados y seguros.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Technology & Security */}
      <section className="py-20 bg-slate-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-200 mb-8" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '800' }}>
              TECNOLOGÍA Y
              <span className="block text-orange-500">SEGURIDAD</span>
            </h2>
            <p className="text-xl text-slate-400 max-w-4xl mx-auto" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '400' }}>
              La seguridad es el pilar de GLCC. Implementamos protocolos de cifrado avanzados, autenticación 2FA y monitoreo constante para proteger cada transacción. Cumplimos con las mejores prácticas de prevención de riesgos y trazabilidad financiera.
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center group">
              <div className="w-20 h-20 bg-gradient-to-br from-orange-500/15 to-orange-600/15 border border-orange-500/20 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-shield-keyhole-line text-3xl text-orange-400"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-200 mb-4" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '700' }}>Cifrado Avanzado</h3>
              <p className="text-slate-500" style={{ fontFamily: '"Inter", sans-serif' }}>Protocolos de cifrado de extremo a extremo para proteger todas las transacciones.</p>
            </div>
            
            <div className="text-center group">
              <div className="w-20 h-20 bg-gradient-to-br from-green-500/15 to-green-600/15 border border-green-500/20 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-fingerprint-line text-3xl text-green-400"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-200 mb-4" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '700' }}>Autenticación 2FA</h3>
              <p className="text-slate-500" style={{ fontFamily: '"Inter", sans-serif' }}>Doble factor de autenticación para máxima seguridad en el acceso.</p>
            </div>
            
            <div className="text-center group">
              <div className="w-20 h-20 bg-gradient-to-br from-blue-500/15 to-blue-600/15 border border-blue-500/20 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-file-shield-line text-3xl text-blue-400"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-200 mb-4" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '700' }}>Cumplimiento Normativo</h3>
              <p className="text-slate-500" style={{ fontFamily: '"Inter", sans-serif' }}>Protocolos que cumplen con las mejores prácticas y regulaciones internacionales.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 bg-gradient-to-br from-slate-900 via-slate-950 to-slate-900 relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-0 left-0 w-96 h-96 bg-orange-500/5 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-slate-700/5 rounded-full blur-3xl"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-200 mb-8" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '800' }}>¿POR QUÉ ELEGIR GLCC?</h2>
            <p className="text-lg text-slate-400 max-w-4xl mx-auto" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '400' }}>
              Al elegirnos, estarás trabajando con una empresa líder en soluciones cripto, que prioriza la transparencia, la seguridad y la eficiencia.
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center group">
              <div className="w-20 h-20 bg-gradient-to-br from-orange-500/15 to-orange-600/15 border border-orange-500/20 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-global-line text-3xl text-orange-400"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-200 mb-4" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '700' }}>LIQUIDEZ GLOBAL</h3>
              <p className="text-slate-500" style={{ fontFamily: '"Inter", sans-serif' }}>Acceso inmediato a grandes volúmenes de compra y venta.</p>
            </div>
            
            <div className="text-center group">
              <div className="w-20 h-20 bg-gradient-to-br from-green-500/15 to-green-600/15 border border-green-500/20 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-shield-check-line text-3xl text-green-400"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-200 mb-4" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '700' }}>SEGURIDAD</h3>
              <p className="text-slate-500" style={{ fontFamily: '"Inter", sans-serif' }}>Protección avanzada de datos y cumplimiento normativo.</p>
            </div>
            
            <div className="text-center group">
              <div className="w-20 h-20 bg-gradient-to-br from-blue-500/15 to-blue-600/15 border border-blue-500/20 rounded-2xl flex items-center justify-center mx-0 mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-lightbulb-line text-3xl text-blue-400"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-200 mb-4" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '700' }}>INNOVACIÓN</h3>
              <p className="text-slate-500" style={{ fontFamily: '"Inter", sans-serif' }}>Tecnología que conecta el sistema financiero tradicional con el cripto.</p>
            </div>
            
            <div className="text-center group">
              <div className="w-20 h-20 bg-gradient-to-br from-slate-600/15 to-slate-700/15 border border-slate-600/20 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-customer-service-line text-3xl text-slate-400"></i>
              </div>
              <h3 className="text-xl font-bold text-slate-200 mb-4" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '700' }}>SOPORTE 24/7</h3>
              <p className="text-slate-500" style={{ fontFamily: '"Inter", sans-serif' }}>Asistencia profesional y respuesta personalizada en todo momento.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contacto" className="py-20 bg-slate-900/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-200 mb-8" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '800' }}>
              CONTÁCTANOS
            </h2>
            <p className="text-xl text-slate-400 max-w-3xl mx-auto" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '400' }}>
              ¿Listo para optimizar tus operaciones en criptomonedas? GLCC es tu aliado estratégico en el mundo cripto.
            </p>
            <p className="text-lg text-slate-500 mt-4" style={{ fontFamily: '"Inter", sans-serif' }}>
              📩 Déjanos tu mensaje y descubre cómo podemos ayudarte a crecer.
            </p>
          </div>
          
          <div className="max-w-2xl mx-auto">
            <div className="bg-slate-900/50 backdrop-blur-sm border border-slate-800/50 rounded-2xl shadow-2xl p-8">
              <form onSubmit={handleSubmit} data-readdy-form id="contacto-glcc">
                <div className="space-y-6">
                  <div>
                    <input
                      type="text"
                      name="nombre"
                      value={formData.nombre}
                      onChange={handleInputChange}
                      placeholder="Nombre..."
                      required
                      className="w-full px-4 py-3 bg-slate-800/50 border border-slate-700/50 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-slate-200 placeholder-slate-500 text-sm transition-all"
                      style={{ fontFamily: '"Inter", sans-serif' }}
                    />
                  </div>
                  
                  <div>
                    <textarea
                      name="mensaje"
                      value={formData.mensaje}
                      onChange={handleInputChange}
                      placeholder="Escribe tu mensaje"
                      rows={6}
                      maxLength={500}
                      required
                      className="w-full px-4 py-3 bg-slate-800/50 border border-slate-700/50 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent resize-none text-slate-200 placeholder-slate-500 text-sm transition-all"
                      style={{ fontFamily: '"Inter", sans-serif' }}
                    ></textarea>
                    <p className="text-xs text-slate-600 mt-1" style={{ fontFamily: '"Inter", sans-serif' }}>Máximo 500 caracteres</p>
                  </div>
                  
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full bg-gradient-to-r from-orange-500 to-orange-600 text-slate-950 py-3 px-6 rounded-lg font-semibold hover:from-orange-600 hover:to-orange-700 transition-all disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer transform hover:scale-105 shadow-lg shadow-orange-500/20"
                    style={{ fontFamily: '"Inter", sans-serif', fontWeight: '700' }}
                  >
                    {isSubmitting ? 'Enviando...' : 'Enviar'}
                  </button>
                  
                  {submitStatus === 'success' && (
                    <div className="text-green-400 text-center font-medium bg-green-400/10 border border-green-400/20 rounded-lg p-3" style={{ fontFamily: '"Inter", sans-serif' }}>
                      ¡Mensaje enviado exitosamente! Te contactaremos pronto.
                    </div>
                  )}
                  
                  {submitStatus === 'error' && (
                    <div className="text-red-400 text-center font-medium bg-red-400/10 border border-red-400/20 rounded-lg p-3" style={{ fontFamily: '"Inter", sans-serif' }}>
                      Error al enviar el mensaje. Por favor, inténtalo de nuevo.
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-950 border-t border-slate-800/50 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div className="md:col-span-2">
              <h3 className="text-2xl font-bold mb-4 tracking-wide" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '800' }}>
                <span className="text-slate-200">GLCC</span>
                <span className="text-orange-500">SAS</span>
              </h3>
              <p className="text-slate-500 mb-6" style={{ fontFamily: '"Inter", sans-serif' }}>
                Soluciones financieras inteligentes para el mundo digital. Tu aliado estratégico en operaciones OTC, P2P, B2B y más.
              </p>
              <div className="flex space-x-4">
                <a href="mailto:info@glccsas.com" className="w-10 h-10 bg-slate-900 border border-slate-800 rounded-full flex items-center justify-center hover:bg-slate-800 hover:border-orange-500 cursor-pointer transition-all">
                  <i className="ri-mail-fill text-lg"></i>
                </a>
                <a href="https://t.me/+573207949001" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-slate-900 border border-slate-800 rounded-full flex items-center justify-center hover:bg-slate-800 hover:border-orange-500 cursor-pointer transition-all">
                  <i className="ri-telegram-fill text-lg"></i>
                </a>
                <a href="https://wa.me/573207949001" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-slate-900 border border-slate-800 rounded-full flex items-center justify-center hover:bg-slate-800 hover:border-orange-500 cursor-pointer transition-all">
                  <i className="ri-whatsapp-fill text-lg"></i>
                </a>
              </div>
            </div>
            
            <div>
              <h4 className="font-bold mb-4 text-orange-400" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '700' }}>Servicios</h4>
              <ul className="space-y-2 text-slate-500" style={{ fontFamily: '"Inter", sans-serif' }}>
                <li><a href="#" className="hover:text-orange-400 cursor-pointer transition-colors">Operaciones OTC</a></li>
                <li><a href="#" className="hover:text-orange-400 cursor-pointer transition-colors">P2P Trading</a></li>
                <li><a href="#" className="hover:text-orange-400 cursor-pointer transition-colors">Soluciones B2B</a></li>
                <li><a href="#" className="hover:text-orange-400 cursor-pointer transition-colors">Swaps Cripto</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="font-bold mb-4 text-orange-400" style={{ fontFamily: '"Inter", sans-serif', fontWeight: '700' }}>Empresa</h4>
              <ul className="space-y-2 text-slate-500" style={{ fontFamily: '"Inter", sans-serif' }}>
                <li><a href="#nosotros" className="hover:text-orange-400 cursor-pointer transition-colors">Nosotros</a></li>
                <li><a href="#servicios" className="hover:text-orange-400 cursor-pointer transition-colors">Servicios</a></li>
                <li><a href="#contacto" className="hover:text-orange-400 cursor-pointer transition-colors">Contacto</a></li>
                <li><a href="#" className="hover:text-orange-400 cursor-pointer transition-colors">Soporte</a></li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-slate-800/50 mt-8 pt-8 text-center text-slate-500" style={{ fontFamily: '"Inter", sans-serif' }}>
            <p>&copy; 2024 GLCCSAS. Todos los derechos reservados. | 
              <a href="https://readdy.ai/?origin=logo" className="hover:text-orange-400 ml-2 cursor-pointer transition-colors">Powered by Readdy</a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
